import PerfilForm from './PerfilForm'
import enhance from './PerfilForm.enhancer'

export default enhance(PerfilForm)



// WEBPACK FOOTER //
// ./src/routes/private/PerfilUsuario/components/PerfilForm/index.js